(function() {
  var fallbackEmail = 'tel-uniquement-no-reply@momentumelectric.com';

  function validFrenchPhone(value) {
    var phone = value.trim().replace(/[\s().-]/g, '');
    return /^(?:0[1-9]\d{8}|\+33[1-9]\d{8}|0033[1-9]\d{8})$/.test(phone);
  }

  function validateContact(form, showError) {
    var phone = form.querySelector('[data-cargo-phone]');
    var email = form.querySelector('[data-cargo-email]');
    var hint = form.querySelector('.mcg-form__hint');
    var phoneValue = phone.value.trim();
    var emailValue = email.value.trim();

    phone.setCustomValidity('');
    if (!phoneValue && !emailValue) phone.setCustomValidity('Indiquez un téléphone ou une adresse e-mail.');
    if (phoneValue && !validFrenchPhone(phoneValue)) phone.setCustomValidity('Saisissez un numéro valide, par exemple 06 12 34 56 78.');
    hint.classList.toggle('is-error', Boolean(showError && phone.validationMessage));
    return !phone.validationMessage;
  }

  function bindLanding(root) {
    if (root.getAttribute('data-hide-site-chrome') === 'true') document.body.classList.add('mcg-page-active');
    var form = root.querySelector('[data-cargo-contact-form]');
    var modelSelect = root.querySelector('[data-cargo-model-select]');
    if (!form) return;

    validateContact(form, false);
    form.querySelectorAll('[data-cargo-phone], [data-cargo-email]').forEach(function(field) {
      field.addEventListener('input', function() { validateContact(form, true); });
    });
    form.addEventListener('submit', function(event) {
      if (!validateContact(form, true) || !form.checkValidity()) return;
      var phone = form.querySelector('[data-cargo-phone]');
      var email = form.querySelector('[data-cargo-email]');
      if (!phone.value.trim() || email.value.trim()) return;
      event.preventDefault();
      window.setTimeout(function() { email.value = fallbackEmail; form.submit(); }, 0);
    });

    root.querySelectorAll('[data-cargo-model]').forEach(function(button) {
      button.addEventListener('click', function() {
        modelSelect.value = button.getAttribute('data-cargo-model');
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  document.querySelectorAll('[data-momentum-cargo]').forEach(bindLanding);
  document.addEventListener('shopify:section:load', function(event) {
    var root = event.target.querySelector('[data-momentum-cargo]');
    if (root) bindLanding(root);
  });
  document.addEventListener('shopify:section:unload', function() {
    if (!document.querySelector('[data-momentum-cargo][data-hide-site-chrome="true"]')) {
      document.body.classList.remove('mcg-page-active');
    }
  });
})();
